import React from 'react';
import PropTypes from 'prop-types';
import './style.less';
import { controlType } from '../../../constants/common';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SearchIcon from '@material-ui/icons/SearchOutlined';
import ResetIcon from '@material-ui/icons/RestorePageOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Button, Chip, Tooltip, IconButton, Paper, Badge, FormControlLabel, Checkbox, FormControl, RadioGroup, Radio, Popover, List, ListItem, ListItemText } from '@material-ui/core';
import moment from 'moment';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FilterIcon from '@material-ui/icons/FilterListOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { applyFilterOnData, removeDuplicates } from '../../../utils/helper';
import _ from 'lodash';
import { CheckBoxOutlineBlank, CloseOutlined, MoreVertOutlined } from '@material-ui/icons';
import { AdvanceFilterOperators, Operators } from '../../../constants/appConstants';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// Page filter component is used to handle filters on the reports and pages
class PageFilter extends React.PureComponent {
  // Constructor to define initial state
  constructor(props) {
    super(props);
    this.state = {
      filterConfig: [],
      selectedData: [],
      autoFilter: true,
      openFilterPane: false,
      openFilter: false,
      filterAlwaysVisible: true,
      internalSelectedData: [],
      defaultSelectedData: []
    };
  }

  // Method is used to get values before components are mounted
  componentDidMount() {
    this.setState({
      // selectedData: this.props.selectedData || [],
      internalSelectedData: this.props.selectedData || [],
      defaultSelectedData: this.props.defaultSelectedData || [],
      filterAlwaysVisible: this.props.filterAlwaysVisible || true
    });
  }

  // Get new state from props
  static getDerivedStateFromProps(newpros, state) {
    if (
      JSON.stringify(newpros.filterConfig) !== JSON.stringify(state.filterConfig) ||
      JSON.stringify(newpros.selectedData) !== JSON.stringify(state.internalSelectedData) ||
      JSON.stringify(newpros.defaultSelectedData) !== JSON.stringify(state.defaultSelectedData) ||
      newpros.autoFilter !== state.autoFilter ||
      newpros.filterAlwaysVisible !== state.filterAlwaysVisible
    ) {
      return {
        defaultSelectedData: newpros.defaultSelectedData || [],
        filterConfig: newpros.filterConfig,
        autoFilter: newpros.autoFilter,
        selectedData: newpros.selectedData || [],
        internalSelectedData: newpros.selectedData || [],
        filterAlwaysVisible: newpros.filterAlwaysVisible === undefined ? true : newpros.filterAlwaysVisible
      };
    }
    return null;
  }

  // render components based on conditions
  render() {
    const { filterConfig } = this.props;
    const { internalSelectedData, openFilterPane, filterAlwaysVisible, openFilter } = this.state;
    return (
      <>
        {filterConfig && (
          <div className="row pageFilter-container bottom-xs start-xs">
            {filterConfig &&
              this.props.autoFilter &&
              (filterAlwaysVisible || openFilter) &&
              filterConfig.map((filter, index) => {
                return this.renderFitter(filter, index);
              })}
            {filterConfig && !this.props.autoFilter && (filterAlwaysVisible || openFilter) && (
              <>
                <div className="col-xs-12 col-lg-12">
                  <div className="row bottom-xs">
                    {filterConfig.map((filter, index) => {
                      return this.renderFitter(filter, index);
                    })}
                  </div>
                </div>
                <div className="col-xs-12 col-lg-12 filter-action-group">
                  <div className="row start-xs end-xs">
                    <div className="col-xs-4 col-sm-3 no-padding">
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<SearchIcon />}
                        onClick={() => {
                          this.setState({
                            internalSelectedData: this.getcleanData()
                            // openFilter: false
                          });
                          this.props.onFilterChanged(this.getcleanData());
                        }}
                      >
                        Search
                      </Button>
                      {/* </div>
                    <div className="col-xs-4 col-sm-1 no-padding"> */}
                      &nbsp; &nbsp;
                      <Button
                        variant="contained"
                        color="default"
                        size="small"
                        startIcon={<ResetIcon />}
                        onClick={() => {
                          this.setState({
                            selectedData: [],
                            internalSelectedData: []
                          });
                          if(this.props.resetPage === undefined){
                            this.props.onFilterChanged(this.state.defaultSelectedData);
                          } else {
                            this.props.resetPage(this.state.defaultSelectedData);
                          }
                          
                        }}
                      >
                        reset
                      </Button>
                    </div>
                    {openFilter && !filterAlwaysVisible && (
                      <div className="col-xs-12 col-sm-1">
                        <Button
                          variant="contained"
                          color="default"
                          size="small"
                          startIcon={<CloseOutlined />}
                          onClick={() => {
                            this.setState({
                              openFilter: false
                            });
                          }}
                        >
                          Close
                      </Button>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {this.props.hidePanel !== true && !openFilter && filterAlwaysVisible === false
              ? (
                this.renderFilterPane(openFilterPane, internalSelectedData)
              )
              : this.props.hidePanel !== true && filterAlwaysVisible &&
                internalSelectedData &&
                internalSelectedData.length > 0 &&
                internalSelectedData.filter((x) => (x.selected || []).length > 0).length
                ? (
                  this.renderFilterPane(openFilterPane, internalSelectedData)
                )
                : (
                  <></>
                )}
          </div>
        )}
      </>
    );
  }

  // Render Applied filters
  renderAppliedFilter = (data) => {
    const { filterConfig } = this.props;
    const appliedFilter = [];
    if (data.selected && data.selected.length > 0) {
      // if (data.type !== 'CheckBox') {
      appliedFilter.push(
        <> <span className="applied-filter-text">
          {filterConfig.find((y) => y.key === data.key).title}</span>
          <span className="applied-filter-text-normal pad-right">
            {data.advanceFilterOperator
              ? data?.advanceFilterOperator?.name
              : filterConfig.find((y) => y.key === data.key).operator
                ? filterConfig.find((y) => y.key === data.key)?.operator?.name
                : 'Equals'}</span>
        </>
      );
      // }
      const values = [];
      const key = (data.displayValue
        ? data.displayValue
        : data.key);
      data.selected.forEach((x, i) => {
        // const label = data.type === 'CheckBox' ? filterConfig.find((y) => y.key === data.key).title : x[data.key];
        let label = data.type === 'CheckBox' ? (x[key] || 'false').toString() : x[key]?.toString();
        label = label === 'true' ? 'True' : label === 'false' ? 'False' : label;
        values.push(
          <Chip
            label={label}
            title={label}
            disabled={filterConfig.find((y) => y.key === data.key).hiddenWhenChild ||
              filterConfig.find((y) => y.key === key).allowreset === false}
            onDelete={() => {
              this.handleDelete(x, data);
            }}
            color="primary"
            variant="outlined"
          />
        );
        if (i < data.selected.length - 1) {
          values.push(
            <>
              <span className="applied-filter-text-normal pad-right pad-left">{
                data?.advanceFilterOperator?.name === 'EqualsTo' ? 'AND' : 'Or'}</span>
            </>
          );
        }
      });
      appliedFilter.push(<span className="applied-filter-value">{values}</span>);
    }
    return <div className="col-xs-auto ">{appliedFilter}</div>;
  };

  // Handle delete event
  handleDelete = (item, data) => {
    const { internalSelectedData } = this.state;
    if (data.type === controlType.Checkbox) {
      (internalSelectedData.find((x) => x.key === data.key) || []).selected[0][data.key] = false;
    } else {
      (internalSelectedData.find((x) => x.key === data.key) || []).selected = data.selected.filter((x) => {
        return x[data.key] !== item[data.key];
      });
    }

    this.props.onFilterChanged(internalSelectedData);
  };

  // Render filter
  renderFitter = (filter, index) => {
    let controlToBind;
    const { selectedData } = this.state;
    let selectedAdvanceFilter = '';
    const key = (filter.displayValue
      ? filter.displayValue
      : filter.key);
    if (filter !== undefined && filter.hideFilter !== true && !this.isHidden(filter)) {
      const defaultValues = [];
      if (selectedData && selectedData.length > 0) {
        const selectedItems = selectedData.find((x) => x.key === filter.key) || {};
        if (filter?.advanceFilter) {
          selectedAdvanceFilter = selectedItems?.advanceFilterOperator?.name || '';
        }
        if (selectedItems && selectedItems.selected) {
          if ((filter.multiple || Array.isArray(selectedItems.selected)) && selectedItems.selected.length > 0) {
            selectedItems.selected.forEach((element) => {
              defaultValues.push(element[key]);
            });
          } else {
            if (selectedItems.selected[filter.key] && selectedItems.selected[filter.key] !== '') {
              defaultValues.push(selectedItems.selected[key]);
            }
          }
        }
      }

      const ignoreFilters = [...filter.ignoreFilters || []];
      ignoreFilters.push(filter.key);
      if (filter.additionalIgnoreFilter && filter.additionalIgnoreFilter !== undefined && filter.additionalIgnoreFilter !== null) {
        ignoreFilters.push(filter.additionalIgnoreFilter);
      }
      let sourceData = applyFilterOnData(filter.source || [], selectedData, ignoreFilters);
      // console.log(filter.key, sourceData, filter.type);
      // if (filter?.distinctOn) {
      //   sourceData = getDistinctByProperty(sourceData, filter?.distinctOn);
      // }
      if (sourceData.length > 0 && filter.ignoreSort !== true) {
        sourceData = _.orderBy(sourceData, [filter.key], (filter.sortOrder === undefined ? ['asc'] : [filter.sortOrder]));
      }
      if ((filter.type === controlType.DropDown || filter.type === controlType.Autofill) && filter.multiple) {
        if (defaultValues && defaultValues.length === 0) {
          defaultValues.push('All');
        }
        sourceData.unshift({ [key]: 'All' });
      }
      switch (filter.type) {
        case controlType.Autofill:

          controlToBind = (
            <Autocomplete
              size="small"
              blurOnSelect
              multiple={filter.multiple || false}
              key={'autocomplete_filter' + index}
              id={'autocomplete_filter' + index}
              options={removeDuplicates((sourceData || []).map((option) => option[key]))}
              value={removeDuplicates(defaultValues)}
              onChange={(event, value) => {
                this.onChange(filter, event, value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={filter.title}
                  margin="normal"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: 'search' }}
                />
              )}
            />
          );
          break;
        case controlType.DropDown:
          if (filter.multiple) {
            controlToBind = (
              <Autocomplete
                blurOnSelect
                size="small"
                multiple={filter.multiple || true}
                disableClearable={filter.disableClearable || false}
                limitTags={2}
                options={removeDuplicates((sourceData || []).map((option) => option[key]))}
                value={filter.multiple === false ? (Array.isArray(defaultValues) ? defaultValues[0] : defaultValues) : defaultValues}
                key={'dropDown_filter' + index}
                id={'dropDown_filter' + index}
                onChange={(event, value) => {
                  this.onChange(filter, event, filter.multiple === false ? (Array.isArray(value) ? value[0] : value) : value);
                }}
                autoHighlight
                renderInput={(params) => <TextField {...params} label={filter.title} margin="normal" />}
              />
            );
          } else {
            controlToBind = (
              <Autocomplete
                blurOnSelect
                multiple={false}
                disableClearable={filter.disableClearable || false}
                size="small"
                options={removeDuplicates((sourceData || []).map((option) => option[filter.key]))}
                value={defaultValues[0] || ''}
                key={'dropDown_filter' + index}
                id={'dropDown_filter' + index}
                onChange={(event, value) => {
                  this.onChange(filter, event, filter.multiple === false ? (Array.isArray(value) ? value[0] : value) : value);
                }}
                renderInput={(params) => <TextField {...params} label={filter.title} margin="normal" />}
              />
            );
          }
          break;
        case controlType.MUIDatePicker:
          controlToBind = (
            <MuiPickersUtilsProvider utils={DateFnsUtils} key={'datePicker_filter' + index}>
              <Grid container>
                <KeyboardDatePicker
                  size="small"
                  clearable={true}
                  format="MM/dd/yyyy"
                  margin="normal"
                  key={'datePicker_filter' + index}
                  id="date-picker-dialog"
                  label={filter.title}
                  value={new Date('2014-08-18T21:11:54')}
                  onChange={(date) => {
                    this.handleDateChange(filter, date);
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />{' '}
              </Grid>
            </MuiPickersUtilsProvider>
          );
          break;
        case controlType.DatePicker:
          controlToBind = (
            <MuiPickersUtilsProvider utils={DateFnsUtils} key={'datePicker_filter' + index}>
              <Grid container>
                <KeyboardDatePicker
                  size="small"
                  clearable={true}
                  format="MM/dd/yyyy"
                  margin="normal"
                  fullWidth
                  id="date-picker-dialog"
                  label={filter.title}
                  value={defaultValues[0] || null}
                  onChange={(date) => {
                    this.handleDateChange(filter, date);
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                  InputProps={{
                    endAdornment: defaultValues[0] && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          this.handleDateChange(filter, null);
                        }}
                      >
                        <ClearIcon size="small" />
                      </IconButton>
                    )
                  }}
                  InputAdornmentProps={{
                    position: 'start'
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          );
          break;
        case controlType.Year:
          controlToBind = (
            <MuiPickersUtilsProvider utils={DateFnsUtils} key={'datePicker_filter' + index}>
              <Grid container>
                <KeyboardDatePicker
                  size="small"
                  clearable={true}
                  error={false}
                  helperText={''}
                  margin="normal"
                  fullWidth
                  id="date-picker-dialog"
                  views={['year']}
                  label={filter.title}
                  minDate={filter.minDate}
                  maxDate={filter.maxDate}
                  value={defaultValues[0] || null}
                  onChange={(date) => {
                    this.handleDateChange(filter, date);
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                  InputProps={{
                    endAdornment: defaultValues[0] && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          this.handleDateChange(filter, null);
                        }}
                      >
                        <ClearIcon size="small" />
                      </IconButton>
                    )
                  }}
                  InputAdornmentProps={{
                    position: 'start'
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          );
          break;
        case controlType.DateRangePicker:
        case controlType.Checkbox: {
          const internalSelectedData =
            (selectedData || []).find(function (ele) {
              return ele.key === filter.key;
            }) || {};
          controlToBind = filter.hiddenWhenChild
            ? (
              <></>
            )
            : (
              <>
                <FormControlLabel
                  key={'checkbox_' + filter.value}
                  value={(internalSelectedData !== undefined && internalSelectedData.selected !== undefined && internalSelectedData.selected.length > 0) ? internalSelectedData.selected[0][filter.key] : false}
                  control={
                    <Checkbox
                      color="primary"
                      checked={(internalSelectedData !== undefined && internalSelectedData.selected !== undefined && internalSelectedData.selected.length > 0) ? internalSelectedData.selected[0][filter.key] : false}
                      onChange={(event) => {
                        const temp = { ...filter };
                        this.onCheckboxChange(temp, filter.value, event.target.checked);
                      }}
                    />
                  }
                  label={filter.title}
                  labelPlacement="end"
                />
              </>
            );
          break;
        }
        case controlType.RadioButton: {
          const internalSelectedData =
            (selectedData || []).find(function (ele) {
              return ele.key === filter.key;
            }) || {};
          // console.log('internalSelectedData', internalSelectedData);
          controlToBind = filter.hiddenWhenChild
            ? (
              <></>
            )
            : (
              <>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    value={((internalSelectedData.selected || [])[0] || {})[filter.key] || 'Market'}
                    onChange={(event) => {
                      const temp = { ...filter };
                      this.onRadioboxChange(temp, event.target.value, true);
                    }}
                  >
                    {filter.options.map((item) => (
                      <FormControlLabel
                        key={'radio' + item.value}
                        value={item.value}
                        control={<Radio color="primary" />}
                        label={item.title}
                        labelPlacement="end"
                      />
                    ))
                    }

                  </RadioGroup>
                </FormControl>

              </>
            );
          break;
        }
        case controlType.TextBox: {
          // const internalSelectedData =
          //   (selectedData || []).find(function (ele) {
          //     return ele.key === filter.key;
          //   });
          // console.log('internalSelectedData', internalSelectedData);
          controlToBind = filter.hiddenWhenChild
            ? (
              <></>
            )
            : (
              <>
                <TextField
                  label={filter.title}
                  fullWidth
                  size="small"
                  onChange={(event, value) => {
                    if (filter.checkString || false === true) {
                      this.onChange(filter, event, event.target.value);
                    } else if (!isNaN(event.target.value) && event.target.value.length < 10) {
                      this.onChange(filter, event, event.target.value);
                    }
                  }}
                  value={defaultValues[0] ?? ''}
                />
              </>
            );
          break;
        }
        case controlType.Label: {
          controlToBind = filter.hiddenWhenChild
            ? (
              <></>
            )
            : (
              <>{filter.title}: {defaultValues[0] ?? ''}</>
            );
          break;
        }
        default:
          break;
      }
      return (
        <div key={'container_filter' + index} className={`col-xs-12 col-lg${filter.gridColumn ? `-${filter.gridColumn}` : this.props.gridColumn ? `-${this.props.gridColumn}` : ''} start-xs`}>
          {filter.advanceFilter
            ? <div className="row bottom-xs">
              <div className="col-xs-11 no-padding">
                {controlToBind}
              </div>
              <div className="col-xs-1 no-padding">
                <Tooltip title="Advance Filter">
                  <IconButton key={'filterApply'} aria-label="Apply filter"
                    size="small"
                    onClick={(e) => this.handleClick(e, filter)}
                  >
                    <MoreVertOutlined
                      className={selectedData?.find(x => x.key === filter.key)?.advanceFilterOperator ? ' selected-color' : 'white-button'}
                      fontSize="small"
                      size="small"
                    />
                  </IconButton></Tooltip>
                {this.state.openMenu && this.state.selectedFilter.key === filter.key && (
                  <Popover
                    id={
                      'PopOver' +
                      filter.key +
                      '_Wrapper'
                    }
                    open={this.state.openMenu}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                  >
                    <List
                      component="nav"
                      aria-label="mailbox folders"
                      className="widgetMenu"
                    >
                      {Operators &&
                        (AdvanceFilterOperators || []).map(
                          (key, i) => (
                            <ListItem
                              size="small"
                              key={'Operator' + i + key}
                              selected={key?.operator?.name === selectedAdvanceFilter || (key?.operator?.name === 'In' && selectedAdvanceFilter === '')}
                              divider
                              button
                              onClick={() => {
                                this.handleClose(key);
                              }}
                            >
                              <ListItemText primary={key.Name} />
                            </ListItem>
                          )
                        )}
                    </List>
                  </Popover>
                )}
              </div>
            </div>
            : controlToBind
          }
        </div>
      );
    }
  };

  // Handle click event
  handleClick = (event, filter) => {
    this.setState({ anchorEl: event.currentTarget, openMenu: true, selectedFilter: filter });
  };

  // Handle close event
  handleClose = (key) => {
    if (key.operator) {
      const { selectedData, selectedFilter } = this.state;
      const newSelectedData = (selectedData || []).filter(function (ele) {
        return ele.key !== selectedFilter.key;
      });
      const selected = (selectedData || []).find(function (ele) {
        return ele.key === selectedFilter.key;
      })?.selected;
      newSelectedData.push({
        ...selectedFilter,
        key: selectedFilter.key,
        type: selectedFilter.type,
        operator: selectedFilter.operator,
        advanceFilterOperator: key.operator,
        isComaSeprated: selectedFilter.isComaSeprated || false,
        selected: selected
      });

      this.setState({ selectedData: newSelectedData, anchorEl: null, openMenu: false });
    } else {
      this.setState({ anchorEl: null, openMenu: false });
    }
  };

  // Filters the data based on Hidden property
  getcleanData = () => {
    const { selectedData } = this.state;
    return selectedData
      .filter(x => !this
        .isHidden(this.props.filterConfig
          .find(y => y.key === x.key)));
  }

  // Check value of Hidden property based on conditions
  isHidden = (filter) => {
    if (filter?.hidewhen === undefined) {
      return false;
    }
    if (filter.hidewhen && filter.hidewhen.key) {
      const { selectedData } = this.state;
      const internalSelectedData =
        (selectedData || []).find(function (ele) {
          return ele.key === filter.hidewhen.key;
        }) || {};
      if ((internalSelectedData.selected || [])
        .find(x => x[filter.hidewhen.key] === filter.hidewhen.value) !== undefined) {
        return true;
      }
    }
    return false;
  }

  // Handle date change event of calendar
  handleDateChange = (filter, date) => {
    const dateSelected = {};
    if (date !== undefined && date != null) {
      dateSelected[filter.key] = moment(date).format('MM/DD/YYYY');
      this.applyNewFilterData(filter, [dateSelected]);
      return;
    }
    this.applyNewFilterData(filter, []);
  };

  DateRangeChange = () => { };

  // Radio button change event
  onRadioboxChange = (filter, event, value) => {
    const newValues = [];

    const a = {};
    a[filter.key] = event;
    newValues.push(a);

    this.applyNewFilterData(filter, newValues);
  };

  // Checkbox change event
  onCheckboxChange = (filter, event, value) => {
    const newValues = [];

    const a = {};
    a[filter.key] = value;
    newValues.push(a);
    this.applyNewFilterData(filter, newValues);
  };

  // Text change event
  onChange = (filter, event, value) => {
    const key = (filter.displayValue
      ? filter.displayValue
      : filter.key);
    if (filter.type !== controlType.TextBox &&
      filter.type !== controlType.TextField &&
      filter.type !== controlType.PhoneNumber &&
      filter.type !== controlType.Checkbox &&
      filter.type !== controlType.RadioButton
    ) {
      if (Array.isArray(value) === false || ((value || []).find(x => x === 'All') === undefined ||
        ((value || []).find(x => x === 'All') !== undefined &&
          value.length === 2))) {
        if (filter.multiple) {
          const selected = filter.source.filter((x) => {
            if (filter.multiple) {
              return value.find((j) => j === x[key]);
            } else {
              return x[key] === [value];
            }
          });
          const selected1 = removeDuplicates(selected, key);
          this.applyNewFilterData(filter, selected1);
        } else {
          const selected = filter.source.find((x) => x[key] === value);
          this.applyNewFilterData(filter, selected);
        }
      } else {
        this.applyNewFilterData(filter, []);
      }
    } else {
      const newValues = [];

      const a = {};
      a[filter.key] = value;
      newValues.push(a);

      this.applyNewFilterData(filter, newValues);
    }
  };

  // Render filter panel
  renderFilterPane(openFilterPane, internalSelectedData) {
    const { openFilter, filterAlwaysVisible } = this.state;
    return (
      <div className="col-xs-12">
        <Paper>
          {/* {(internalSelectedData.length > 0) && ( */}
          <div className="row applied-filter-container" >
            <div className="col-xs-12" >
              <Tooltip title={openFilterPane ? 'Collapse' : 'Expand'}>
                <IconButton aria-label="expand row" size="small" onClick={() => this.setState({ openFilterPane: !openFilterPane })}>
                  {openFilterPane ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </Tooltip>
              <Badge color="primary" badgeContent={(internalSelectedData || []).filter((x) => x.selected?.length > 0)?.length} >
                <span className="applied-filter-header">Applied Filters</span>
              </Badge>

              <span className="applied-filter-count"></span>
              {!openFilter && !filterAlwaysVisible && (
                <p className="filterPane-action">
                  <Tooltip title="Show All Filters">
                    <IconButton key={'filterApply'} aria-label="Apply filter" size="small" onClick={() => this.setState({ openFilter: !openFilter })}>
                      <FilterIcon size="small" />
                    </IconButton></Tooltip>
                    Open Filter Pane
                  <Tooltip title="Reset Filters">
                    <IconButton
                      key={'filterReset'}
                      aria-label="Reset filter"
                      size="small"
                      onClick={() => {
                        this.setState({
                          selectedData: _.cloneDeep(this.state.defaultSelectedData),
                          internalSelectedData: _.cloneDeep(this.state.defaultSelectedData)
                        });
                        this.props.onFilterChanged(this.state.defaultSelectedData);
                      }}
                    >
                      <ResetIcon size="small" />
                    </IconButton></Tooltip>
                    Reset filter(s)
                </p>
              )}
            </div>
            {openFilterPane && (
              <div className="col-xs-12">
                <hr></hr>
                <div className="row start-xs">
                  {internalSelectedData.map((data, i) => {
                    const comp = this.renderAppliedFilter(data);
                    // console.log(internalSelectedData);
                    return i < internalSelectedData.length - 1 && internalSelectedData[i]?.selected && internalSelectedData[i]?.selected.length > 0 && internalSelectedData[i + 1]?.selected && internalSelectedData[i + 1]?.selected.length > 0
                      ? <>{comp}<span className='applied-filter-text-normal pad-left'>AND</span></>
                      : comp;
                  })}
                </div>
              </div>
            )}
          </div>
          {/* )} */}
        </Paper>
      </div>
    );
  }

  // Apply filtered data
  applyNewFilterData(filter, selected) {
    const { selectedData } = this.state;
    let newSelectedData = (selectedData || []).filter(function (ele) {
      return ele.key !== filter.key;
    });
    const selectedFilter = (selectedData || []).find(function (ele) {
      return ele.key === filter.key;
    });
    newSelectedData.push({
      ...filter,
      key: filter.key,
      type: filter.type,
      operator: filter.operator,
      advanceFilterOperator: selectedFilter?.advanceFilterOperator,
      isComaSeprated: filter.isComaSeprated || false,
      selected: selected
    });
    this.setState({ selectedData: newSelectedData });
    const isHandleClick = filter.isHandleClick || false;
    const resetFilter = filter.resetFilter || [];
    if (this.props.autoFilter || isHandleClick) {
      // this.setState({ internalSelectedData: newSelectedData });
      if (resetFilter.length > 0) {
        resetFilter.forEach(x => {
          newSelectedData = newSelectedData.filter(y => y.key !== x);
        });
      }
      this.props.onFilterChanged(newSelectedData);
    }
  }
}

PageFilter.propTypes = {
  filterConfig: PropTypes.array.isRequired,
  autoFilter: PropTypes.bool,
  onFilterChanged: PropTypes.func.isRequired,
  gridColumn: PropTypes.number,
  selectedData: PropTypes.array,
  filterAlwaysVisible: PropTypes.bool
};
export default PageFilter;
